/*
 *
 * MessagesHomePopups
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 20-Mar-2025
*/

import React, { useState } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import PurifyAndReplaceHTML from 'Utility/PurifyAndReplaceHTML'
import './MessagesHomePopups.scss'

const MessagesHomePopups = (props) => {
  const { newsInfo } = props
  const [fullContent, setFullContent] = useState(false)

  const handleReadAndConfirm = () => {
    setFullContent(true)
    props.actions.doSetRetrieveTTLread({ id: newsInfo.id || '' })
  }

  const handleConfirm = () => {
    props.actions.doHideTtl()
    props.actions.doRetrieveTTL()
  }

  const messageDate = moment(newsInfo.publishDate).format('DD/MM/YYYY - HH:mm').toUpperCase()

  return (
    <Toggle>
      {fullContent && !props.isLoading && props.isTTLread
        ? (
          <MerchantModal
            topBarTitle={messageDate}
            title={newsInfo.title}
            description={PurifyAndReplaceHTML(newsInfo.content)}
            primaryButtonLabel={formattedMessage.confirm}
            primaryAction={() => handleConfirm()}
            primaryButtonLoading={props.isLoading}
          />
          )
        : (
          <MerchantModal
            topBarTitle={messageDate}
            title={newsInfo.title}
            description={PurifyAndReplaceHTML(newsInfo.shortContent)}
            primaryButtonLabel={formattedMessage.readAndConfirm}
            primaryAction={() => handleReadAndConfirm()}
            primaryButtonLoading={props.isLoading}
          />
          )}
    </Toggle>
  )
}

MessagesHomePopups.propTypes = {
  actions: PropTypes.object,
  newsInfo: PropTypes.object,
  isLoading: PropTypes.bool,
  isTTLread: PropTypes.bool
}

MessagesHomePopups.defaultProps = {
  actions: {},
  newsInfo: {},
  isLoading: false,
  isTTLread: false
}

export default MessagesHomePopups
